/* =||= */
import { fetchURI } from '../value/values'

//--
// S3へアクセスしてデータを取ってくる
export async function s3Request() {
  var fileURL = fetchURI();
  // var fileURL = fileName;
  // レスポンスはそのまま返す
  return await fetch(fileURL).then(async (res) => res);
}
